import { createApp } from "vue";
import App from "./App.vue";
import PrimeVue from "primevue/config";
import Button from "primevue/button";
import Dropdown from "primevue/dropdown";
import "./assets/styles.scss";
import { BootstrapIconsPlugin } from "bootstrap-icons-vue";
import vReveal from "./directives/v-reveal.js";
import vTilt from "./directives/v-tilt.js";
import vDecrypt from "./directives/v-decrypt.js";
import Particles from "@tsparticles/vue3";
import { loadFull } from "tsparticles";

createApp(App)
  .use(PrimeVue)
  .use(BootstrapIconsPlugin)
  .use(Particles, {
    init: async (engine) => {
      await loadFull(engine);
    },
  })
  .component("Dropdown", Dropdown)
  .component("Button", Button)
  .directive("reveal", vReveal)
  .directive("tilt", vTilt)
  .directive("decrypt", vDecrypt)
  .mount("#app");
